var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-view"},[_c('img',{style:(_vm.checkScreenSize ? `filter: drop-shadow(13px 0px currentColor);` : `filter: drop-shadow(999px 0px currentColor);`),attrs:{"src":_vm.iSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }